import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { Icons } from '../icons';

export default function SearchInput({ value, onChange, placeholder = 'Search…' }) {
  return <div className="list-search"><SafeIcon icon={Icons.Search} /><input value={value} onChange={(event) => onChange(event.target.value)} placeholder={placeholder} /></div>;
}